import { render, staticRenderFns } from "./matterApproval.vue?vue&type=template&id=01bee2ff&"
import script from "./matterApproval.vue?vue&type=script&lang=js&"
export * from "./matterApproval.vue?vue&type=script&lang=js&"
import style0 from "./matterApproval.vue?vue&type=style&index=0&id=01bee2ff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports